var React = require('react');

function SocialInstagram (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"instagram"},React.createElement("path",{"id":"social-instagram","d":"M9.5,12A2.5,2.5,0,1,1,12,14.5,2.48,2.48,0,0,1,9.5,12Zm8-5V8.5A.47.47,0,0,1,17,9H15.5a.47.47,0,0,1-.5-.5V7a.47.47,0,0,1,.5-.5H17A.47.47,0,0,1,17.5,7Zm-1.6,4h1.6v6a.47.47,0,0,1-.5.5H7a.47.47,0,0,1-.5-.5V11H8.1A3.4,3.4,0,0,0,8,12a4,4,0,0,0,8,0A3.4,3.4,0,0,0,15.9,11ZM12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Zm7,17V7a2,2,0,0,0-2-2H7A2,2,0,0,0,5,7V17a2,2,0,0,0,2,2H17A2,2,0,0,0,19,17Z","fill":"#FFF"})));
}

SocialInstagram.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = SocialInstagram;

SocialInstagram.default = SocialInstagram;
